import { GrowthBook } from '@growthbook/growthbook'
import firebase from 'firebase/compat/app'
import {
  COHORT_FIREBASE_KEYS_MAP,
  COHORT_GROWTHBOOK_KEYS_MAP,
} from 'nove8/constants/ab-tests'
import { Cohort } from 'nove8/constants/root-constants'
import { CurrentEnvironment, EventLoggerInstanceName } from 'root-constants'
import { Amplitude } from 'services/amplitude.service'
import { eventLogger } from 'services/eventLogger.service'
import { getAbTestOptions } from './getAbTestOptions'
import { getGrowthbookVariantData } from './getGrowthbookVariantData'
import { getRemoteConfigVariantData } from './getRemoteConfigVariantData'
import { mergeAbTestVariantData } from './mergeAbTestVariantData'

export const addAmplitudeLogger = ({
  amplitudeApiKey,
  uuid,
  utmTags,
  cohort,
  language,
  firebaseRemoteConfig,
  growthbook,
  country,
}: {
  amplitudeApiKey: string
  uuid: string
  utmTags: Record<string, string>
  cohort: Cohort
  language: string
  firebaseRemoteConfig: firebase.remoteConfig.RemoteConfig | null
  growthbook: GrowthBook | null
  country: string
}): void => {
  const isProdEnvironment =
    import.meta.env.CURRENT_ENV === CurrentEnvironment.PROD

  const amplitudeService = new Amplitude({
    apiKey: amplitudeApiKey,
    instanceName: EventLoggerInstanceName.AMPLITUDE,
    userId: uuid,
    utmTags: {
      ...utmTags,
      uuid,
    },
    isProdEnvironment,
  })

  const remoteConfigVariantValue = mergeAbTestVariantData({
    cohort,
    firebaseRemoteConfigVariantData: getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey: COHORT_FIREBASE_KEYS_MAP[cohort],
    }),
    growthbookVariantData: getGrowthbookVariantData({
      growthbook,
      growthbookKey: COHORT_GROWTHBOOK_KEYS_MAP[cohort],
    }),
  })

  const woofzAbTestOptions = getAbTestOptions({
    cohort,
    language,
    remoteConfigVariantValue,
    country,
  })

  amplitudeService.configure({
    cohort,
    options: woofzAbTestOptions || {},
  })
  eventLogger.addLoggers([amplitudeService])
}
